"use client";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container"; // LOCAL CUSTOM COMPONENT
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";

import CartStepper from "./default/cart-stepper";
import { CardSectionContextProvider, CartStepBarList } from "./default/context";
import CardSectionStepCart from "./default/step-cart";
import CardSectionStepDetails from "./default/step-checkout";
import CardSectionStepPayment from "./default/step-payment";
import CardSectionStepReview from "./default/step-review";

export interface VariantProps {
  stepConfig: {
    /** @default "Giỏ hàng" */
    cartLabel: string;
    /** @default "/cart" */
    cartPath?: string;
    /** @default "Chi tiết" */
    detailLabel: string;
    /** @default "/cart/details" */
    detailPath?: string;
    /** @default "Thanh toán" */
    paymentLabel: string;
    /** @default "/cart/payment" */
    paymentPath?: string;
    /** @default "Xem lại" */
    reviewLabel: string;
    /** @default "/cart/review" */
    reviewPath?: string;
  };
}

const CardSection = (props: VariantProps) => {
  const pathname = usePathname();
  const [stepList, setStepList] = React.useState<CartStepBarList[]>([
    {
      path: props.stepConfig?.cartPath ?? "/cart",
      title: props.stepConfig?.cartLabel ?? "Giỏ hàng",
    },
    {
      path: props.stepConfig?.detailPath ?? "/cart/details",
      title: props.stepConfig?.detailLabel ?? "Chi tiết",
      disabled: true,
    },
    {
      path: props.stepConfig?.paymentPath ?? "/cart/payment",
      title: props.stepConfig?.paymentLabel ?? "Thanh toán",
      disabled: true,
    },
    {
      path: props.stepConfig?.reviewPath ?? "/cart/review",
      title: props.stepConfig?.reviewLabel ?? "Xem lại",
      disabled: true,
    },
  ]);
  const activeIndex = stepList.findIndex((step) => step.path === pathname);
  const [selectedStep, setSelectedStep] = useState(~activeIndex ? activeIndex + 1 : 1);
  const router = useRouter();

  const handleStepChange = (stepIndex: number) => {
    router.push((stepList[stepIndex] || stepList[0]).path);
  };

  useEffect(() => {
    const activeIndex = stepList.findIndex((step) => step.path === pathname);
    setSelectedStep(~activeIndex ? activeIndex + 1 : 1);
  }, [pathname]);

  const render = () => {
    const activeIndex = stepList.findIndex((step) => step.path === pathname);
    if (activeIndex === 0) return <CardSectionStepCart nextUrl={stepList[1].path} />;
    if (activeIndex === 1) {
      return <CardSectionStepDetails backUrl={stepList[0].path} nextUrl={stepList[2].path} />;
    }
    if (activeIndex === 2) {
      return <CardSectionStepPayment backUrl={stepList[1].path} nextUrl={stepList[3].path} />;
    }
    if (activeIndex === 3) {
      return <CardSectionStepReview backUrl={stepList[2].path} />;
    }
    return null;
  };

  return (
    <CardSectionContextProvider stepList={stepList} setStepList={setStepList}>
      <Container
        sx={{
          my: 4,
        }}
      >
        <Box
          mb={3}
          display={{
            sm: "block",
            xs: "none",
          }}
        >
          <CartStepper
            stepperList={stepList}
            selectedStep={selectedStep}
            onChange={handleStepChange}
          />
        </Box>

        {render()}
      </Container>
    </CardSectionContextProvider>
  );
};

export default CardSection;
